import {
	RocketLaunch,
	TwitterLogo,
	InstagramLogo,
	TiktokLogo,
} from "@phosphor-icons/react";

const socialLinks = [
	{
		icon: TwitterLogo,
		href: "https://x.com/myproxi_ng",
		label: "Twitter",
	},
	{
		icon: InstagramLogo,
		href: "https://www.instagram.com/myproxi.ng",
		label: "Instagram",
	},
	{
		icon: TiktokLogo,
		href: "https://www.tiktok.com/@myproxi.ng",
		label: "TikTok",
	},
];

const lagosAreas = [
	{ label: "Lekki", slug: "lekki" },
	{ label: "Victoria Island", slug: "victoria-island" },
	{ label: "Ikoyi", slug: "ikoyi" },
	{ label: "Yaba", slug: "yaba" },
	{ label: "Surulere", slug: "surulere" },
	{ label: "Ajah", slug: "ajah" },
	{ label: "Ikeja", slug: "ikeja" },
	{ label: "Lagos Island", slug: "lagos-island" },
	{ label: "Gbagada", slug: "gbagada" },
	{ label: "Magodo", slug: "magodo" },
	{ label: "Maryland", slug: "maryland" },
	{ label: "Festac", slug: "festac" },
	{ label: "Ogudu", slug: "ogudu" },
	{ label: "Agege", slug: "agege" },
];

const errandTypes = [
	{ label: "Grocery Delivery", slug: "grocery-delivery" },
	{ label: "Pharmacy Runs", slug: "pharmacy-runs" },
	{ label: "Document Pickup", slug: "document-pickup" },
	{ label: "Queue Standing", slug: "queue-standing" },
	{ label: "Food Runs", slug: "food-runs" },
	{ label: "Parcel Delivery", slug: "parcel-delivery" },
	{ label: "Bank Runs", slug: "bank-runs" },
	{ label: "School Runs", slug: "school-runs" },
	{ label: "Market Runs", slug: "market-runs" },
	{ label: "Airport Pickup", slug: "airport-pickup" },
	{ label: "Utility Bill Payments", slug: "utility-bill-payments" },
	{ label: "Laundry Pickup", slug: "laundry-pickup" },
	{ label: "Confidential Errands", slug: "confidential-errands" },
];

const proxiLinks = [
	{ label: "How It Works", href: "/#trust" },
	{ label: "Services", href: "/#services" },
	{ label: "Trust & Escrow", href: "/#trust" },
	{ label: "FAQ", href: "/faq" },
	{ label: "Support", href: "mailto:support@myproxi.ng" },
	{ label: "Terms of Service", href: "/terms" },
	{ label: "Privacy Policy", href: "/privacy" },
];

export function Footer() {
	return (
		<footer className="bg-primary pt-24 pb-12 px-4 relative overflow-hidden rounded-t-[3rem] mt-12">
			{/* Background Decorations */}
			<div className="absolute inset-0 overflow-hidden pointer-events-none">
				<div className="absolute -top-40 -right-40 w-96 h-96 bg-white/10 rounded-full blur-3xl" />
				<div className="absolute -bottom-40 -left-40 w-96 h-96 bg-secondary/20 rounded-full blur-3xl" />
				<svg
					className="absolute top-20 left-20 w-16 h-16 text-white/20 animate-spin"
					style={{ animationDuration: "20s" }}
					viewBox="0 0 24 24"
					fill="none"
					stroke="currentColor"
					strokeWidth={1}
					aria-hidden="true"
				>
					<path
						d="M12 2L15 8L21 9L16 14L18 20L12 17L6 20L8 14L3 9L9 8L12 2Z"
						strokeLinejoin="round"
					/>
				</svg>
			</div>

			<div className="max-w-6xl mx-auto relative z-10">
				{/* CTA */}
				<div className="text-center">
					<h2 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-white mb-4 tracking-tight leading-[1.1]">
						Ready to get your{" "}
						<span className="font-script text-secondary inline-block rotate-2">
							time back?
						</span>
					</h2>
					<p className="text-lg text-white/80 mb-10 max-w-[340px] mx-auto font-medium">
						Join the waitlist. Be among the first Nigerians to delegate the day,
						the safe way.
					</p>

					{/* 3D Download Button */}
					<div className="max-w-md mx-auto mb-16">
						<button
							type="button"
							data-tally-open="Bza1xR"
							data-tally-layout="modal"
							data-tally-width="700"
							data-tally-emoji-text="👋"
							data-tally-emoji-animation="wave"
							className="w-full flex items-center justify-center gap-2 bg-secondary text-dark py-4 rounded-2xl font-extrabold text-xl shadow-[0_6px_0_0_#009c7a] hover:translate-y-[2px] hover:shadow-[0_4px_0_0_#009c7a] active:translate-y-[4px] active:shadow-none transition-all"
						>
							Join the Waitlist <RocketLaunch size={22} weight="bold" />
						</button>
					</div>
				</div>

				{/* SEO Link Grid — Lagos areas, errand types, and site links */}
				<div className="grid grid-cols-2 md:grid-cols-3 gap-8 md:gap-12 pt-12 pb-12 border-t border-white/15">
					<div>
						<p className="text-white font-bold text-sm uppercase tracking-widest mb-4">
							Errand Service in Lagos
						</p>
						<ul className="space-y-2">
							{lagosAreas.map((area) => (
								<li key={area.slug}>
									<a
										href={`/errands/lagos/${area.slug}`}
										className="text-blue-100/80 hover:text-white text-sm transition-colors"
									>
										Errands in {area.label}
									</a>
								</li>
							))}
						</ul>
					</div>

					<div>
						<p className="text-white font-bold text-sm uppercase tracking-widest mb-4">
							Errand Types
						</p>
						<ul className="space-y-2">
							{errandTypes.map((type) => (
								<li key={type.slug}>
									<a
										href={`/errands/type/${type.slug}`}
										className="text-blue-100/80 hover:text-white text-sm transition-colors"
									>
										{type.label}
									</a>
								</li>
							))}
						</ul>
					</div>

					<div className="col-span-2 md:col-span-1">
						<p className="text-white font-bold text-sm uppercase tracking-widest mb-4">
							Proxi
						</p>
						<ul className="space-y-2">
							{proxiLinks.map((link) => (
								<li key={link.label}>
									<a
										href={link.href}
										className="text-blue-100/80 hover:text-white text-sm transition-colors"
									>
										{link.label}
									</a>
								</li>
							))}
						</ul>
					</div>
				</div>

				{/* Footer Bottom */}
				<div className="w-full border-t border-white/20 pt-8 flex flex-col items-center gap-6">
					{/* Logo */}
					<div className="flex items-center gap-2 opacity-90">
						<img
							src="/illustrations/logo-mark.svg"
							alt="Proxi"
							className="h-8 w-auto brightness-0 invert"
						/>
						<span className="font-bold text-2xl tracking-tight text-white">
							Proxi
						</span>
					</div>

					{/* Social */}
					<div className="flex gap-4">
						{socialLinks.map((social) => (
							<a
								key={social.label}
								href={social.href}
								aria-label={social.label}
								className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-white/20 transition-colors"
							>
								<social.icon size={20} weight="fill" />
							</a>
						))}
					</div>

					{/* Copyright */}
					<p className="text-blue-300/60 text-[11px] mt-2 uppercase tracking-widest font-bold text-center">
						&copy; {new Date().getFullYear()} myProxi Digital Solutions Ltd. —
						On-demand errand service in Lagos, Nigeria.
					</p>
				</div>
			</div>
		</footer>
	);
}
